<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0162 17.1086C8.07457 17.1086 6.1329 16.8003 4.29123 16.1836C3.59123 15.9419 3.0579 15.4503 2.82457 14.8086C2.5829 14.1669 2.66623 13.4586 3.04957 12.8253L4.0079 11.2336C4.2079 10.9003 4.39123 10.2336 4.39123 9.84193V7.43359C4.39123 4.33359 6.91623 1.80859 10.0162 1.80859C13.1162 1.80859 15.6412 4.33359 15.6412 7.43359V9.84193C15.6412 10.2253 15.8246 10.9003 16.0246 11.2419L16.9746 12.8253C17.3329 13.4253 17.3996 14.1503 17.1579 14.8086C16.9162 15.4669 16.3912 15.9669 15.7329 16.1836C13.8996 16.8003 11.9579 17.1086 10.0162 17.1086ZM10.0162 3.05859C7.6079 3.05859 5.64123 5.01693 5.64123 7.43359V9.84193C5.64123 10.4503 5.39123 11.3503 5.0829 11.8753L4.12457 13.4669C3.94123 13.7753 3.89123 14.1003 3.99957 14.3753C4.09957 14.6586 4.34957 14.8753 4.69123 14.9919C8.17457 16.1586 11.8662 16.1586 15.3496 14.9919C15.6496 14.8919 15.8829 14.6669 15.9912 14.3669C16.0996 14.0669 16.0746 13.7419 15.9079 13.4669L14.9496 11.8753C14.6329 11.3336 14.3912 10.4419 14.3912 9.83359V7.43359C14.3912 5.01693 12.4329 3.05859 10.0162 3.05859Z"
      :fill="color"
    />
    <path
      d="M11.5668 3.2834C11.5085 3.2834 11.4502 3.27507 11.3918 3.2584C11.1502 3.19173 10.9168 3.14173 10.6918 3.1084C9.98351 3.01673 9.30018 3.06673 8.65851 3.2584C8.42518 3.3334 8.17518 3.2584 8.01684 3.0834C7.85851 2.9084 7.80851 2.6584 7.90018 2.4334C8.24184 1.5584 9.07518 0.983398 10.0252 0.983398C10.9752 0.983398 11.8085 1.55007 12.1502 2.4334C12.2335 2.6584 12.1918 2.9084 12.0335 3.0834C11.9085 3.21673 11.7335 3.2834 11.5668 3.2834Z"
      :fill="color"
    />
    <path
      d="M10.0166 19.0088C9.1916 19.0088 8.3916 18.6755 7.80827 18.0921C7.22493 17.5088 6.8916 16.7088 6.8916 15.8838H8.1416C8.1416 16.3755 8.3416 16.8588 8.6916 17.2088C9.0416 17.5588 9.52494 17.7588 10.0166 17.7588C11.0499 17.7588 11.8916 16.9171 11.8916 15.8838H13.1416C13.1416 17.6088 11.7416 19.0088 10.0166 19.0088Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      default: "#292626",
      type: String,
    },
  },
};
</script>
